{
  "instances": {
    "beans": {
      "label": "Beans",
      "name": "Nombre",
      "aliases": "Alias",
      "type": "Tipo",
      "resource": "Recurso",
      "dependencies": "Dependencias"
    }
  }
}
